export const socialLinks = {
    faceBook:"https://www.facebook.com/",
    instagram:"https://www.instagram.com/",
    twitter:"https://twitter.com/",
    linkedin:"https://linkedin.com/",
    pinterest:"https://www.pinterest.com/",
    youtube:"https://www.youtube.com/"
}